import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab, useTheme } from '@mui/material';

import { SettingsFields } from '@bandido/shared/types';

import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { LocalPhone, Mail } from '@mui/icons-material';
import { Settings } from '@frontend/features/agencies/components/Settings';
import { useGetSettingsByAgencyId } from '@frontend/features/agencies/queries';

export const CommunicationSettings = () => {
  const theme = useTheme();
  const [selectedTab, setSelectedTab] = useState(0);
  const { t } = useTranslation();
  const { id } = useParams();

  const { data: settings } = useGetSettingsByAgencyId({ id });

  const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        borderRadius: 3,
        backgroundColor: theme.palette.common.white,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        height: 'calc(100vh - 180px)',
        overflow: 'hidden',
        padding: 3,
      }}
    >
      <Tabs value={selectedTab} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto">
        <Tab icon={<LocalPhone />} iconPosition="start" label={t('agencies.settings.phone')} />
        <Tab icon={<Mail />} iconPosition="start" label={t('agencies.settings.email')} />
      </Tabs>

      <OverlayScrollbarsComponent
        style={{
          marginTop: theme.spacing(5),
          boxSizing: 'border-box',
          width: '100%',
          overflowY: 'hidden',
          height: 'calc(100vh - 364px)',
        }}
        className="overlayscrollbars-react"
        options={{ scrollbars: { autoHide: 'leave', theme: 'os-theme-light' } }}
        defer
      >
        {selectedTab === 0 && (
          <>
            <Settings
              title={t('agencies.settings.twilio')}
              agencyId={Number(id)}
              fields={[
                SettingsFields.TWILIO_ACCOUNT_SID,
                SettingsFields.TWILIO_TRUNK_SID,
                SettingsFields.TWILIO_TWIML_APP_SID,
                SettingsFields.TWILIO_PHONE_NUMBER,
                SettingsFields.TWILIO_AUTH_TOKEN,
                SettingsFields.TWILIO_API_KEY,
                SettingsFields.TWILIO_API_KEY_SECRET,
              ]}
              values={settings}
            />
          </>
        )}

        {selectedTab === 1 && (
          <Box display="flex" flexDirection="column" gap={5}>
            <Settings
              title={t('agencies.settings.sendgrid')}
              agencyId={Number(id)}
              values={settings}
              fields={[
                SettingsFields.SENDGRID_API_KEY,
                SettingsFields.SENDGRID_SENDER_EMAIL,
                SettingsFields.SENDGRID_INBOUND_MAILS,
              ]}
              options={{
                fieldTypes: [
                  {
                    id: SettingsFields.SENDGRID_INBOUND_MAILS,
                    type: 'multi-select',
                    options: [],
                  },
                ],
              }}
            />
            <Settings
              title={t('agencies.settings.gmail')}
              agencyId={Number(id)}
              values={settings}
              fields={[SettingsFields.MAIL_CREDENTIAL]}
            />
          </Box>
        )}
      </OverlayScrollbarsComponent>
    </Box>
  );
};
